export default {
  dataPermission: (state) => {
    return state.dataPermission
  }
}
